import HeroArea from "@muzfed/components/HeroArea";

const Home = () => {
  return <HeroArea />;
};

export default Home;
